const STORAGE_KEY = 'esganga_cookie_consent';
const CONSENT_EVENT = 'esganga:consent-changed';

const DEFAULT_CONSENT = {
    necessary: true,
    analytics: false,
    marketing: false,
    decidedAt: null
};

function getConsent() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) {
            return null;
        }
        return { ...DEFAULT_CONSENT, ...JSON.parse(raw) };
    } catch (error) {
        return null;
    }
}

function setConsent(partial) {
    const next = {
        ...DEFAULT_CONSENT,
        ...(getConsent() || {}),
        ...partial,
        necessary: true,
        decidedAt: new Date().toISOString()
    };
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: next }));
    return next;
}

function hasDecided() {
    return Boolean(getConsent()?.decidedAt);
}

export { getConsent, setConsent, hasDecided, DEFAULT_CONSENT, CONSENT_EVENT };
